import { FC, useEffect } from "react";

type TextType = {
  text: string;
};

const RoundedCircleText: FC<TextType> = ({ text }) => {
  useEffect(() => {
    const element = document.getElementById("circle_text") as HTMLElement;
    if (element) {
      const arr: Array<string> = ` ${text}`.split("");
      element.innerHTML = arr
        .map(
          (char: any, i: any) =>
            `<span style='transform:rotate(${
              i * (360 / arr?.length)
            }deg)'> ${char} </span>`
        )
        .join("");
    }
  }, [text]);

  return (
    <div className="circle_text">
      <p id="circle_text"></p>
    </div>
  );
};

export default RoundedCircleText;
